import './index.css';

function toggleAccordion() {
  const accordionTitles = document.querySelectorAll('.accordion__title');

  if (accordionTitles) {
    for (let i = 0; i < accordionTitles.length; i++) {
      const accordionWrapper = accordionTitles[i].closest('.accordion__wrapper');
      const accordionContent = accordionWrapper.querySelector('.accordion__content');
      accordionWrapper.classList.add('js-ready');
      accordionWrapper.classList.add('js-collapsed');
      accordionContent.style.height = '0';
      accordionContent.style.overflowY = 'hidden';

      accordionTitles[i].addEventListener('click', function (e) {
        const targetWrapper = e.target.closest('.accordion__wrapper');
        const targetContent = targetWrapper.querySelector('.accordion__content');

        if (targetContent.style.height === '0px') {
          targetWrapper.classList.remove('js-collapsed');
          targetWrapper.classList.add('js-expanded');
          targetContent.style.height = targetContent.scrollHeight + 'px';
        } else {
          targetContent.style.height = '0';
          targetWrapper.classList.remove('js-expanded');
          targetWrapper.classList.add('js-collapsed');
        }
      });
    }
  }
}

toggleAccordion();

import gsap from 'gsap';

const wrappers = document.querySelectorAll('.portrait__wrapper');

if (wrappers) {
  wrappers.forEach((wrapper) => {
    let profile = wrapper.querySelector('.portrait__profile');
    let childElements = profile.children;

    let timeline = gsap.timeline({ paused: true });
    timeline.to(profile, {
      transform: 'translate(1, 2rem) rotateY(180deg)',
      zIndex: -1,
      duration: 0.075,
    });
    timeline.to(profile, {
      transform: 'translate(calc(50% + 2rem), 2rem) rotateY(180deg)',
      zIndex: -1,
      duration: 0.25,
      ease: 'power4.in',
    });
    timeline.to(profile, { transform: 'translate(calc(50% + 2rem), 2rem) rotateY(0deg)', zIndex: 1, duration: 0.5 });
    timeline.to(childElements, { opacity: 1, duration: 0.15 }, '<+=0.15');
    timeline.to(profile, {
      transform: 'translate(0, 2rem) rotateY(0)',
      zIndex: 1,
      duration: 0.25,
      ease: 'power4.out',
    });
    timeline.to(profile, {
      transform: 'translate(1rem, 2rem) rotateY(0)',
      zIndex: 1,
      duration: 0.075,
    });

    wrapper.addEventListener('touchstart', () => {
      timeline.reversed() ? timeline.play() : timeline.reverse();
    });

    wrapper.addEventListener('mouseover', () => {
      timeline.play();
    });
    wrapper.addEventListener('mouseout', () => {
      timeline.reverse();
      timeline.play();
      timeline.reverse();
    });
  });
}
